import React from "react";

import "./index.scss";

export default function ProvidersCard({
  image,
  title,
  descr,
  name,
  id,
  setPickedItem, styles
}) {
  return (
    <div className="providers__block" style={styles}>
      <input type="radio" name={name} id={id} />
      <label
        htmlFor={id}
        className="providers__card"
        onClick={() => {
          setPickedItem(id);
        }}
      >
        <div className="image">
          <img src={image} alt="image" />
        </div>
        <div className="title">{title}</div>
        <div className="checked">
          <img src="/assets/icons/check-icon.svg" alt="mark" />
        </div>
      </label>
    </div>
  );
}
